import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import ShowcaseCarousel from './ShowcaseCarousel';
import ShowcaseModal from './ShowcaseModal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TABS = [
  { id: 'all', label: 'All' },
  { id: 'business', label: 'Business & Corporate' },
  { id: 'event', label: 'Weddings & Events' },
];

/** Real partner & event label showcase. Renders nothing until at least one active item exists. */
const CorpShowcase = ({ onOrder, onPartner }) => {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState('business');
  const [filter, setFilter] = useState('all');
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    axios.get(`${API}/portfolio/public`).then((r) => {
      setData(r.data);
      if (!r.data.items.some((i) => i.category === 'business') && r.data.items.some((i) => i.category === 'event')) setTab('event');
    }).catch(() => {});
  }, []);

  const items = useMemo(() => {
    if (!data) return [];
    return data.items.filter((i) => (tab === 'all' || i.category === tab) && (filter === 'all' || i.subcategory === filter));
  }, [data, tab, filter]);

  if (!data || data.items.length === 0) return null;

  const subcats = tab === 'all' ? [] : (data.subcategories[tab] || []);
  const cats = new Set(data.items.map((i) => i.category));
  const visibleTabs = cats.size > 1 ? TABS : TABS.filter((t) => cats.has(t.id));

  return (
    <>
      <section className="ff-section corp-showcase" data-testid="corp-showcase">
        <div className="ff-container ff-text-center">
          <p className="ff-eyebrow" style={{ color: 'var(--ff-gold)' }}>REAL LABELS · REAL BUSINESSES · REAL CELEBRATIONS</p>
          <h2>Made for Businesses Like Yours.</h2>
          <p className="ff-lede" style={{ maxWidth: 680, margin: '10px auto 0' }}>
            See how businesses, professionals, couples and organizations have made The Lokal their own.
          </p>

          {visibleTabs.length > 1 && (
            <div className="corp-tabs" role="tablist" data-testid="showcase-tabs">
              {visibleTabs.map((t) => (
                <button key={t.id} role="tab" aria-selected={tab === t.id}
                        className={tab === t.id ? 'on' : ''} data-testid={`showcase-tab-${t.id}`}
                        onClick={() => { setTab(t.id); setFilter('all'); }}>
                  {t.label}
                </button>
              ))}
            </div>
          )}

          {subcats.length > 1 && (
            <div className="corp-filters" data-testid="showcase-filters">
              <button className={filter === 'all' ? 'on' : ''} onClick={() => setFilter('all')} data-testid="showcase-filter-all">All</button>
              {subcats.map((s) => (
                <button key={s.value} className={filter === s.value ? 'on' : ''} onClick={() => setFilter(s.value)}
                        data-testid={`showcase-filter-${s.value}`}>{s.label}</button>
              ))}
            </div>
          )}
        </div>

        <ShowcaseCarousel items={items} onSelect={setSelected} />

        <div className="ff-container ff-text-center corp-imagine" data-testid="corp-imagine">
          <h2>Now Imagine Yours.</h2>
          <p className="ff-lede">Your logo. Your artwork. Your message. Your wine.</p>
          <div style={{ display: 'inline-flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center', marginTop: 8 }}>
            <button className="ff-btn ff-btn-primary ff-btn-lg" onClick={() => onOrder('showcase_create')} data-testid="showcase-create-cta">
              Create Your Custom Wine
            </button>
            <button className="ff-btn ff-btn-ghost ff-btn-lg" onClick={() => onPartner('showcase_partner')} data-testid="showcase-partner-cta">
              Become a Lokal Partner
            </button>
          </div>
        </div>
      </section>

      <ShowcaseModal item={selected} onClose={() => setSelected(null)}
                     onCreate={() => { setSelected(null); onOrder('showcase_modal_create'); }} />
    </>
  );
};

export default CorpShowcase;
